/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { AttributeValue, SimpleProduct } from '@msdyn365-commerce/retail-proxy';

import { IModuleProps, INodeProps, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as MsDyn365 from '@msdyn365-commerce/core';

import classnames from 'classnames';
import * as React from 'react';

import {
    IBuyboxAddToOrderTemplateViewProps, IBuyboxAddToWishlistViewProps,
    IBuyboxKeyInPriceViewProps,
    IBuyboxProductConfigureViewProps, IBuyboxProductQuantityViewProps, IBuyboxShopSimilarLookViewProps,
    IBuyboxState } from '@msdyn365-commerce-modules/buybox';
import { ICittaEnquireonlyBuyboxData } from './citta-enquireonly-buybox.data';
import { ICittaEnquireonlyBuyboxProps } from './citta-enquireonly-buybox.props.autogenerated';
import { IBuyboxFindInStoreViewProps } from './components/citta-enquireonly-buybox-find-in-store';

export interface IBuyboxViewProps extends ICittaEnquireonlyBuyboxProps<ICittaEnquireonlyBuyboxData> {
    state: IBuyboxState;
    ModuleProps: IModuleProps;
    ProductInfoContainerProps: INodeProps;
    MediaGalleryContainerProps: INodeProps;
    mediaGallery?: React.ReactNode;
    imageContainer?: React.ReactNode;
    productSpecs?: React.ReactNode;
    AccordianContainerProps: INodeProps;
    accordian?: React.ReactNode;
    title?: React.ReactNode;
    description?: MsDyn365.RichText | undefined;
    rating?: React.ReactNode;
    price?: React.ReactNode;
    addToOrderTemplate?: IBuyboxAddToOrderTemplateViewProps;
    addToWishlist?: IBuyboxAddToWishlistViewProps;
    addToCart: React.ReactNode;
    findInStore?: IBuyboxFindInStoreViewProps;
    quantity?: IBuyboxProductQuantityViewProps;
    configure?: IBuyboxProductConfigureViewProps;
    inventoryLabel?: React.ReactNode;
    shopSimilarLook?: IBuyboxShopSimilarLookViewProps;
    shopSimilarDescription?: IBuyboxShopSimilarLookViewProps;
    telemetryContent?: ITelemetryContent;
    keyInPrice?: IBuyboxKeyInPriceViewProps;
    unitOfMeasure?: React.ReactNode;
}

interface ICittaBuyboxState extends IBuyboxState {
    product?: SimpleProduct;
    productAttributes?:AttributeValue[];
}

/**
 * Buybox Module.
 */
class Buybox extends React.PureComponent<ICittaEnquireonlyBuyboxProps<ICittaEnquireonlyBuyboxData>, ICittaBuyboxState> {
    constructor(props: ICittaEnquireonlyBuyboxProps<ICittaEnquireonlyBuyboxData>, state: ICittaBuyboxState) {
        super(props);
        this.state = {
            product: undefined,
            productAttributes: undefined,
            errorState: {
                configureErrors: {}
            },
            quantity: 1,
            min: undefined,
            max: undefined,
            selectedProduct: undefined,
            productPrice: undefined,
            productDeliveryOptions: undefined,

            modalOpen: false,
            isUpdatingDimension: false,
            isUpdatingDeliveryOptions: false
        };
    }

    public render(): JSX.Element | null {
        const {
            slots: {
                imageContainer,
                enquireNow,
                productSpecs
            },
            config: { className = 'citta-enquireonly-buybox' }
        } = this.props;


        const viewProps: IBuyboxViewProps = {
            ...(this.props as ICittaEnquireonlyBuyboxProps<ICittaEnquireonlyBuyboxData>),
            state: this.state,
            mediaGallery: imageContainer, //mediaGallery && mediaGallery.length > 0 ? mediaGallery[0] : undefined,

            ModuleProps: {
                moduleProps: this.props,
                className: classnames('ms-buybox', className)
            },
            ProductInfoContainerProps: {
                className: 'ms-buybox__content'
            },
            MediaGalleryContainerProps: {
                className: 'ms-buybox__media-gallery'
            },
            AccordianContainerProps: {
                className: 'ms-buybox__accordian'
            },
            title: this.props.config.productTitle,
            description: this.props.config.productDetails,
            addToCart: enquireNow,
            productSpecs: productSpecs
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }

}

export default Buybox;
